
<template>
  <div class="avatar-container">
    <img src="../../assets/im.png" class="avatar" alt="头像">
    <div 
      class="chat-bubble" 
      :class="{ 'show': isVisible }"
      ref="bubble"
    >
      {{ displayedText }}
      <span class="cursor" v-if="isTyping">|</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      isTyping: false,
      fullText: '您好有什么可以帮您？',
      displayedText: '',
      charIndex: 0,
      timer: null,
      cycleTimer: null
    }
  },
  mounted() {
    this.startAnimationCycle()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    clearInterval(this.cycleTimer)
  },
  methods: {
    startAnimationCycle() {
      this.playAnimation()
      this.cycleTimer = setInterval(() => {
        this.playAnimation()
      }, 10000)
    },
    playAnimation() {
      this.resetAnimation()
      setTimeout(() => {
        this.isVisible = true
        this.isTyping = true
        this.typeWriter()
      }, 5000)
    },
    resetAnimation() {
      this.isVisible = false
      this.isTyping = false
      this.displayedText = ''
      this.charIndex = 0
    },
    typeWriter() {
      if (this.charIndex < this.fullText.length) {
        this.displayedText += this.fullText.charAt(this.charIndex)
        this.charIndex++
        this.timer = setTimeout(this.typeWriter, 150)
      } else {
        this.isTyping = false
      }
    }
  }
}
</script>

<style scoped>
.avatar-container {
  position: relative;
  display: inline-block;
  margin: 20px;
}

.avatar {
  /* width: 60px;
  height: 60px; */
  /* border-radius: 50%; */
  object-fit: cover;
}

.chat-bubble {
  position: absolute;
  right: 70px;
  top: -10px;
  width: 0;
  min-width: 180px;  /* 加宽确保单行显示 */
  padding: 12px 15px;
  background: linear-gradient(135deg, #4facfe 0%, #2bd0d9 100%);
  color: white;
  border-radius: 12px 0 12px 12px;
  opacity: 0;
  overflow: hidden;
  white-space: nowrap;  /* 强制不换行 */
  box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  transition: 
    width 0.6s cubic-bezier(0.25, 1, 0.5, 1),
    opacity 0.4s ease,
    transform 0.4s ease;
  transform: translateX(20px);
}

.chat-bubble.show {
  width: auto;
  opacity: 1;
  transform: translateX(0);
}

.chat-bubble::before {
  content: '';
  position: absolute;
  top: 15px;
  left: -10px;
  border-width: 8px 10px 8px 0;
  border-style: solid;
  border-color: transparent #4facfe transparent transparent;
}

.cursor {
  animation: blink 0.7s infinite;
  opacity: 1;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}
</style>
